@use "../../../../../../styles/Constants.scss" as Constants;

.save-signature-modal {

	&__text {
		padding-bottom: Constants.$val-spacing-l;

		&--margin-top {
			margin-top: Constants.$val-spacing-m;
		}
	}
}